<template>
     <v-card
    max-width="100%"
  >

    <v-list two-line subheader>
      <a class="link__link" :key="link.id" v-for="link in links" v-on:click="clickLink(link.link)">

        <v-list-item
          
        >

          <v-list-item-avatar>
          <v-icon color="primary">mdi-earth</v-icon>

          </v-list-item-avatar>

          <v-list-item-content>
              <v-list-item-title v-text="link.name"></v-list-item-title>
              <v-list-item-subtitle v-text="link.link"></v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
                  <v-icon color="primary"> mdi-chevron-right</v-icon>
          </v-list-item-action>
        </v-list-item>
    </a>
      
    </v-list>
  </v-card>
</template>

<style lang="scss">

 .link__link{
    text-decoration: none !important;



  }



    .v-icon {
     color: white;
      font-size: 40px;
  }
</style>
<script>
import hubbdata from "@/hubbdata";

export default {
    name: "Links",
    
    data() {
        return {
        }
    },
    methods: {
        clickLink(link) {    
          if (link.indexOf("http") > -1){
            // window.open(target.href, '_system');
            openUrl(link, false) // eslint-disable-line
          }
          else {
            openUrl("http://" + link.href, false) // eslint-disable-line
          }
        }
    },
    computed: {
           links() {
            return hubbdata.getters.getLinksByCategory(this.$route.params.id)
        },
      
    }
}

</script>